// extracted by mini-css-extract-plugin
module.exports = {"root":"Dialogue_root__qPETi","dialogueBtn":"Dialogue_dialogueBtn__h1_P7","mask":"Dialogue_mask__he65g","closeBtn":"Dialogue_closeBtn__FsUwO"};